// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HkWR","fullView":"styles_fullView__12QQd"};